import styles from './index.module.scss';

export default function NoteTitle ({
  isUrgent,
  title,
}: {
  isUrgent: boolean;
  title: string;
}) {
  return (
    <h2
      className={styles['note-title']}
      data-e='note-title'
      data-urgent={isUrgent}
    >
      {title}
    </h2>
  );
}
